import { useAppDispatch } from 'hooks'
import { useEffect, useState } from 'react'
import { Outlet, useParams } from 'react-router-dom'
import { getAppSetting } from 'services/appService'
import { setAppSetting } from '../redux/slices/appSlice'
import Page404 from './page404/page404'

const PublicRouter = () => {
  const { app } = useParams()
  const dispatch = useAppDispatch()
  const [isMatchUrl, setIsMatchUrl] = useState(true)

  const handleGetAppSetting = async () => {
    const appSetting = await getAppSetting({ app_id: app as string })
    if (appSetting.success) {
      dispatch(setAppSetting(appSetting.data))
    } else {
      setIsMatchUrl(false)
    }
  }

  useEffect(() => {
    const timeOut = setTimeout(() => {
      handleGetAppSetting()
    }, 100)
    return () => {
      clearTimeout(timeOut)
    }
  }, [app])

  if (!isMatchUrl) {
    return <Page404 />
  }

  return <Outlet />
}

export default PublicRouter
